module.exports = __webpack_public_path__ + "static/media/indexacapital--logo.24958a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/indexacapital/indexacapital--logo.svg
// module id = 179
// module chunks = 0